import React, { useState } from 'react';
import './styles.scss'
import ErrorIcon from '../../assets/error-icon.png'
import PBVLogo from '../../assets/pbv.png'
import Button from '../../components/Button/Button'

const SubmissionErrorScreen = ({
    errorInfo,
    orgLogo,
    formSpec,
    setNextPage,
    setSubmissionError,
    setShowSummary
}) => {

    const goBackToForm = () => {
        setNextPage(false)
        setSubmissionError(false)
        setShowSummary(false)
        sessionStorage.setItem('previousSubmission', true);
        console.log(sessionStorage)
    }

    console.log(errorInfo)

    return (
        <div id='submission-error-screen'>
            <img id='submission-error-org-logo' className='org-logo' src={orgLogo} alt="organization logo" style={{ width: 200 }} />
            <div id='submission-error-content'>
                <img id='submission-error-icon' src={ErrorIcon} alt="error" />
                <h4>Something went wrong</h4>
                <p>We’re sorry, but we ran into an issue submitting your request. Our team is working to resolve the problem.</p>
                <p id='se-error-code'>Error Code: {`${errorInfo.status}789-1`}</p>
                <Button label={'Back to Form'} onClick={goBackToForm} icon={null} />
            </div>
            <img id='submission-error-pbv-logo' className='pbv-logo' src={PBVLogo} alt="Powered By Verisma" />
        </div>
    )
}

export default SubmissionErrorScreen;